import React from 'react'
import { Loader as LoaderIcon } from '../../icons'

const Loader = ({ className }) => {
  return <LoaderIcon className={'pb-loader ' + className} />
}

export default Loader
